/**
 * 비필수 CMS/weegloo 콘텐츠 쿼리 공통 옵션 (quiz 로컬).
 *
 * 배경: 마케팅/프로모션/카테고리 등 "곁다리 콘텐츠"는 소비처가 모두 `data?.` 로 방어한다.
 * 그런데 quiz 전역 QueryClient 는 `queries.throwOnError: true` 라서, 이 콘텐츠 GET 이
 * 500(weegloo WEB500007 등) 을 뱉으면 GlobalErrorBoundary 로 전파돼 페이지 전체가 죽는다
 * (play PLAY-APP-AZY / web WEB-APP-1RD 와 동일 메커니즘).
 *
 * - throwOnError:false → 콘텐츠 실패가 페이지를 죽이지 않게 한다. 관측성은 `_app` 의
 *   queryCache onError → handleError 가 그대로 유지한다(Sentry 계속 보고).
 * - 캐싱 강화 + 백그라운드 패치 억제 → 재방문·포커스마다 weegloo/CMS 를 다시 때리지 않는다
 *   (500/hang 노출 빈도↓).
 *
 * suspense 쿼리(createSuspenseQuery)는 로컬 ErrorBoundary 로 이미 감싸져 있고 suspense 는
 * throwOnError 와 무관하게 던지므로, 캐싱만 적용하는 CONTENT_CACHE_OPTIONS 를 쓴다.
 */
export const CONTENT_CACHE_OPTIONS = {
  staleTime: 10 * 60 * 1000,
  gcTime: 60 * 60 * 1000,
  refetchOnWindowFocus: false,
} as const;

export const NON_CRITICAL_CONTENT_QUERY_OPTIONS = {
  ...CONTENT_CACHE_OPTIONS,
  throwOnError: false,
} as const;
